import { types } from './actions';

const initialState = {
  direction: null,
  isOpen: false,
  isSaving: false,
  nodeIds: [],
  quoteItemId: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.OPEN:
      return {
        ...state,
        isOpen: true,
        direction: payload.direction,
        quoteItemId: payload.quoteItemId,
        nodeIds: payload.nodeIds,
      };
    case types.CLOSE:
      return {
        ...initialState,
      };
    case types.MOVE_NODE_DOWN_ERROR:
    case types.MOVE_NODE_UP_ERROR:
      return {
        ...state,
        isSaving: false,
      };
    case types.MOVE_NODE_DOWN_REQUEST:
    case types.MOVE_NODE_UP_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.quotes.bomRestructuringDrawerReducer;

export const getDirection = (state) => getScope(state).direction;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsSaving = (state) => getScope(state).isSaving;

export const getNodeIds = (state) => getScope(state).nodeIds;

export const getQuoteItemId = (state) => getScope(state).quoteItemId;
